import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import ktkService from "../../../services/ktkService";

import { Button } from "../../commonComponents/Buttons";
import InputFields from "../../commonComponents/InputFields/InputFields";

import "./kidsTeachKids.scss";

function ChannelManagement() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  let inputRef;
  const currentUserBirthday = useSelector(
    (state) => state?.user?.userInfo?.birthday
  );
  const [userFile, setUserFile] = useState();
  const [userImage, setUserImage] = useState(null);
  const [userBirthday, setUserBirthday] = useState();

  useEffect(() => {
    if (!location?.state?.ifEdit) {
      if (currentUserBirthday) {
        let today = new Date();
        let birthDate = new Date(currentUserBirthday);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setUserBirthday(age);
      }
    }
  }, [location, currentUserBirthday]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
    defaultValues: {
      title: "",
      description: "",
    },
  });

  useEffect(() => {
    if (location?.state?.ifEdit) {
      setValue("title", location?.state?.kidChannel?.data?.title);
      setValue("description", location?.state?.kidChannel?.data?.description);
      if (location?.state?.kidChannel?.data?.not_approved_avatar) {
        setUserImage(location?.state?.kidChannel?.data?.not_approved_avatar);
      } else {
        setUserImage(location?.state?.kidChannel?.data?.channel_avatar);
      }
    }
  }, [location, setValue]);

  function fileSelectedHandler(e) {
    const reader = new FileReader();
    if (e?.target?.files[0]) {
      reader.readAsDataURL(e?.target?.files[0]);
      reader.onload = () => {
        setUserFile(e?.target?.files[0]);
        setUserImage(reader.result);
      };
    }
  }

  function checkAllData(data) {
    if (data) {
      let formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      if (userFile) {
        formData.append("channel_avatar", userFile);
      }

      if (location?.state?.ifEdit) {
        ktkService
          .patchKidChannel(location?.state?.kidChannel?.data?.id, formData)
          .then((response) => {
            if (response?.status === 200) {
              navigate(-1);
            }
          });
      } else {
        ktkService.postNewChannels(formData).then((response) => {
          if (response?.status === 201) {
            navigate(`/kids-teach-kids/channel/${response?.data?.id}`);
          }
        });
      }
    }
  }

  function renderPhotoApproveMsg() {
    if (
      (userImage && !location?.state?.ifEdit) ||
      (location?.state?.ifEdit &&
        userImage !== location?.state?.kidChannel?.data?.channel_avatar)
    ) {
      return (
        <li>
          <p className="imageAlert">{t("photoAprove")}</p>
        </li>
      );
    }
  }

  return (
    <main className="ktkBg">
      <Button
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        onClick={() => navigate(-1)}
      />
      <section className="uploadBlock">
        {location?.state?.ifEdit ? (
          <h2>{t("channelEdit")}</h2>
        ) : (
          <h2>{t("channelCreate")}</h2>
        )}
        <form onSubmit={handleSubmit(checkAllData)}>
          <fieldset>
            <ul className="formFieldsList">
              <li>
                <div className="imageInput">
                  <label
                    onClick={() => inputRef.click()}
                    className="avatarVignette"
                  >
                    {userImage ? (
                      <picture className="selectedImageBlock">
                        <img
                          src={userImage}
                          className="selectedImage"
                          alt="User"
                        />
                      </picture>
                    ) : (
                      <span className="notSelectedImageBlock">
                        <em className="textBlock">{t("choosePhoto")}</em>
                      </span>
                    )}
                  </label>
                  <input
                    className="invisibleBlock"
                    accept="image/*"
                    type="file"
                    ref={(ref) => (inputRef = ref)}
                    onChange={fileSelectedHandler}
                  />
                </div>
              </li>
              {renderPhotoApproveMsg()}
              <li>
                <label className="inputLabel">{t("yourAge")}: </label>
                {location?.state?.kidChannel?.data?.user?.age ||
                userBirthday ? (
                  <p className="birthMessage">
                    {location?.state?.kidChannel?.data?.user?.age &&
                      location?.state?.kidChannel?.data?.user?.age}{" "}
                    {userBirthday && userBirthday} {t("yearsCrop")}
                  </p>
                ) : (
                  <p className="birthMessage">{t("missingInfo")}</p>
                )}
              </li>
              <li>
                <InputFields
                  errors={errors}
                  inputType="inputName"
                  register={register}
                  fieldName="title"
                  lableName="Channel Title"
                />
              </li>
              <li>
                <InputFields
                  errors={errors}
                  inputType="textArea"
                  register={register}
                  fieldName="description"
                  lableName="Channel description"
                />
              </li>
              <li>
                <Button
                  type="submit"
                  label={
                    location?.state?.ifEdit
                      ? t("saveChanges")
                      : t("channelCreate")
                  }
                  viewType="mainBtn"
                />
              </li>
            </ul>
          </fieldset>
        </form>
      </section>
    </main>
  );
}

export default ChannelManagement;
